// extracted by mini-css-extract-plugin
export default {"hideTooltip":"f--z","fadeIn":"g--z","delay":"h--z","recommendedSizeTooltip":"i--z"};